module.exports = __webpack_public_path__ + "static/img/weather14.55a1b4fa.png";